import { csrfFetch } from "./csrf.js";
import { gcoreServerUrl } from '../config';
import { MATERIAL_ITEM_TYPE, PREFERENCE_ITEM_TYPE } from '../constants/itemTypes';

const INIT_GCOMPONENT_ITEM = 'gcomponentItem/initGComponentItem'; 
const SET_GCOMPONENT_ITEM = 'gcomponentItem/setGComponentItem';
const REMOVE_GCOMPONENT_ITEM = "gcomponentItem/removeGComponentItem";
const INIT_GCOMPONENT_ITEMS = 'gcomponentItem/initGComponentItems'; 
const SET_GCOMPONENT_ITEMS = 'gcomponentItem/setGComponentItems';
const SET_GCOMPONENT_ITEMS_SPECIFIC = 'gcomponentItem/setGComponentItemsSpecific';
const SET_GCOMPONENT_ITEMS_BY_ITEM_TYPE = 'gcomponentItem/setGComponentItemsByItemType';
const SET_GCOMPONENT_ITEMS_NOT_MINES_BY_ITEM_TYPE = 'gcomponentItem/setGComponentItemsNotMinesByItemType';

const initGComponentItem = () => ({
  type: INIT_GCOMPONENT_ITEM,
});

const initGComponentItems = () => ({
  type: INIT_GCOMPONENT_ITEMS,
});

const setGComponentItem = (gcomponentItem) => ({
  type: SET_GCOMPONENT_ITEM,
  payload: gcomponentItem,
});

const removeGComponentItem = () => ({
  type: REMOVE_GCOMPONENT_ITEM,
});

const setGComponentItems = (gcomponentItems) => ({
  type: SET_GCOMPONENT_ITEMS,
  payload: gcomponentItems,
});

const setGComponentItemsSpecific = (gcomponentItemsSpecific) => ({
  type: SET_GCOMPONENT_ITEMS_SPECIFIC,
  payload: gcomponentItemsSpecific,
});

const setGComponentItemsByItemType = (gcomponentItemsByItemType) => ({
  type: SET_GCOMPONENT_ITEMS_BY_ITEM_TYPE,
  payload: gcomponentItemsByItemType,
});

const setGComponentItemsNotMinesByItemType = (gcomponentItemsNotMinesByItemType) => ({
  type: SET_GCOMPONENT_ITEMS_NOT_MINES_BY_ITEM_TYPE,
  payload: gcomponentItemsNotMinesByItemType,
});


export const create = ({ id, name, code, gcomponentId, /*gclientId, gclient, specification,*/ g04docuGCertificationId, comments, applyType, dependentGcomponentItem, itemType, madeBy, selectedClassifications }) => async dispatch => {
  const response = await csrfFetch(dispatch, `${gcoreServerUrl}/api/gcomponentItems`, {
    method: "POST",
    body: JSON.stringify({ id, name, code, gcomponentId, /*gclientId, gclient, specification,*/ g04docuGCertificationId, comments, applyType, dependentGcomponentItem, itemType, madeBy, selectedClassifications }),
  });
  const data = await response.json();
  dispatch(setGComponentItem(data.gcomponentItem));
  return response;
};

export const modify = ({ id, name, code, gcomponentId, /*gclientId, gclient, specification,*/ g04docuGCertificationId, comments, applyType, dependentGcomponentItem, itemType, madeBy, selectedClassifications }) => async dispatch => {
  const response = await csrfFetch(dispatch, `${gcoreServerUrl}/api/gcomponentItems`, {
    method: "PUT",
    body: JSON.stringify({ id, name, code, gcomponentId, /*gclientId, gclient, specification,*/ g04docuGCertificationId, comments, applyType, dependentGcomponentItem, itemType, madeBy, selectedClassifications }),
  });
  const data = await response.json();
  dispatch(setGComponentItem(data.gcomponentItem));
  return response;
};

export const modifyApplyType = ({ id, applyType }) => async dispatch => {
  const response = await csrfFetch(dispatch, `${gcoreServerUrl}/api/gcomponentItems/applyType`, {
    method: "PUT",
    body: JSON.stringify({ id, applyType }),
  });
  const data = await response.json();
  dispatch(setGComponentItem(data.gcomponentItem));
  return response;
};

export const modifyItemType = ({ id, itemType }) => async dispatch => {
  const response = await csrfFetch(dispatch, `${gcoreServerUrl}/api/gcomponentItems/itemType`, {
    method: "PUT",
    body: JSON.stringify({ id, itemType }),
  });
  const data = await response.json();
  dispatch(setGComponentItem(data.gcomponentItem));
  return response;
};

export const modifyMadeBy = ({ id, madeBy }) => async dispatch => {
  const response = await csrfFetch(dispatch, `${gcoreServerUrl}/api/gcomponentItems/madeBy`, {
    method: "PUT",
    body: JSON.stringify({ id, madeBy }),
  });
  const data = await response.json();
  dispatch(setGComponentItem(data.gcomponentItem));
  return response;
};

export const modifyGComponentItemValid = ({ id, valid }) => async dispatch => {
  const response = await csrfFetch(dispatch, `${gcoreServerUrl}/api/gcomponentItems/valid`, {
    method: "PUT",
    body: JSON.stringify({ id, valid }),
  });
  const data = await response.json();
  dispatch(setGComponentItem(data.gcomponentItem));
  return response;
};

export const selectAll = () => async dispatch => {
  const response = await csrfFetch(dispatch, `${gcoreServerUrl}/api/gcomponentItems`);
  const data = await response.json();
  dispatch(setGComponentItems(data.gcomponentItems));
  return response;
}

export const selectAllDirect = async () => {
  const response = await csrfFetch(null, `${gcoreServerUrl}/api/gcomponentItems/`);
  const data = await response.json();
  return data.gcomponentItems;
}

export const selectAllByQuery = () => async dispatch => {
  const response = await csrfFetch(dispatch, `${gcoreServerUrl}/api/gcomponentItems/query/selectAll`);
  const data = await response.json();
  dispatch(setGComponentItems(data.gcomponentItems));
  return response;
};

export const selectAllByGcomponentId = (gcomponentId) => async dispatch => {
  const response = await csrfFetch(dispatch, `${gcoreServerUrl}/api/gcomponentItems/gcomponentId/${gcomponentId}`);
  const data = await response.json();
  dispatch(setGComponentItems(data.gcomponentItems));
  return response;
}

export const selectAllByGcomponentCode = (gcomponentCode) => async dispatch => {
  const response = await csrfFetch(dispatch, `${gcoreServerUrl}/api/gcomponentItems/gcomponentCode/${gcomponentCode}`);
  const data = await response.json();
  dispatch(setGComponentItemsSpecific(data.gcomponentItems));
  return response;
}

export const selectAllByGcomponentCodeDirect = async (gcomponentCode) => {
  const response = await csrfFetch(null, `${gcoreServerUrl}/api/gcomponentItems/gcomponentCode/${encodeURIComponent(gcomponentCode)}`);
  const data = await response.json();
  return data.gcomponentItems || [];
}

export const selectAllByGcomponentIdDirect = async (gcomponentId) => {
  const response = await csrfFetch(null, `${gcoreServerUrl}/api/gcomponentItems/gcomponentId/${gcomponentId}`);
  const data = await response.json();
  return data.gcomponentItems;
}

export const selectAllByGcomponentIdByQuery = (gcomponentId) => async dispatch => {
  const response = await csrfFetch(dispatch, `${gcoreServerUrl}/api/gcomponentItems/query/selectAllByGcomponentId/${gcomponentId}`);
  const data = await response.json();
  dispatch(setGComponentItems(data.gcomponentItems));
  return response;
};

export const selectAllByItemTypeByQuery = (itemType) => async dispatch => {
  const response = await csrfFetch(dispatch, `${gcoreServerUrl}/api/gcomponentItems/query/selectAll/itemType/${itemType}`);
  const data = await response.json();
  dispatch(setGComponentItemsByItemType(data.gcomponentItemsByItemType));
  return response;
};

// TODO : itemType별로 검색하는 API와 다르게 여러개의 itemType을 검색하는 것이 다름.
// 실제로 GComponentItems를 원자재/가공부자재와 시공부자재를 통합하고 규격(수치값들)을 새로 부여하며 DBGrid 검색이 바뀌어 생성됨.
export const selectAllByItemTypesByQuery = (itemTypes) => async dispatch => {
  const response = await csrfFetch(dispatch, `${gcoreServerUrl}/api/gcomponentItems/query/selectAll/itemTypes`, {
    method: 'POST',
    body: JSON.stringify({ itemTypes }),
  });
  const data = await response.json();
  dispatch(setGComponentItems(data.gcomponentItems));
  return response;
};

export const selectNotMinesByItemTypeByQuery = (gclientId, itemType) => async dispatch => {
  const response = await csrfFetch(dispatch, `${gcoreServerUrl}/api/gcomponentItems/query/selectAll/notMines/gclient/${gclientId}/itemType/${itemType}`);
  const data = await response.json();
  dispatch(setGComponentItemsNotMinesByItemType(data.gcomponentItemsNotMinesByItemType));
  return response;
};
  
export const select = (id) => async dispatch => {
  const response = await csrfFetch(dispatch, `${gcoreServerUrl}/api/gcomponentItems/${id}`);
  const data = await response.json();
  dispatch(setGComponentItem(data.gcomponentItem));
  return response;
}

export const selectByQuery = (id) => async dispatch => {
  const response = await csrfFetch(dispatch, `${gcoreServerUrl}/api/gcomponentItems/query/select/${id}`);
  const data = await response.json();
  dispatch(setGComponentItem(data.gcomponentItem));
  return response;
}

// itemType별 콤보박스 데이터 조회
export const selectItemTypeComboData = (itemType) => async dispatch => {
  const url = new URL(`${gcoreServerUrl}/api/gcomponentItems/v2/selectItemTypeComboData`);
  url.searchParams.append('itemType', itemType);

  const response = await csrfFetch(dispatch, url.toString());
  const data = await response.json();
  return data;
}

export const selectAllItemTypeListByItemType = (itemType, gcomponentId, g04docuGCertificationId) => async dispatch => {
  const url = new URL(`${gcoreServerUrl}/api/gcomponentItems/v2/query/selectAll/itemTypes`);
  url.searchParams.append('itemType', itemType);    
  // gcomponentId와 g04docuGCertificationId를 OR 조건으로 처리
  if (gcomponentId) {
    url.searchParams.append('gcomponentId', gcomponentId);
  }
  if (g04docuGCertificationId) {
    url.searchParams.append('g04docuGCertificationId', g04docuGCertificationId);
  }

  const response = await csrfFetch(dispatch, url.toString());
  const data = await response.json();
  return data;
}

export const initializeGComponentItem = () => dispatch => {
  // TODO : 초기값 선택 여부 검토
  // dispatch(setGComponentItem(null));
  // dispatch(setGComponentItem(initialState.gcomponentItem));
  dispatch(initGComponentItem());
}

export const initializeGComponentItems = () => dispatch => {
  dispatch(initGComponentItems());
}

export const remove = (id) => async (dispatch) => {
  const response = await csrfFetch(dispatch, `${gcoreServerUrl}/api/gcomponentItems/${id}`, {
    method: "DELETE",
  });
  dispatch(removeGComponentItem());
  return response;
};

export const reorder = async ({ type, id }) => {
  const response = await csrfFetch(null, `${gcoreServerUrl}/api/gcomponentItems/reorder`, {
    method: "POST",
    body: JSON.stringify({ type, id }),
  });
  
  return response;
}

// 원자재/가공부자재/시공부자재 순서 변경
export const modifyRowOrder = async ({ id, type, toOrder, itemType, itemId }) => {

  let requestBody;

  if (itemType === MATERIAL_ITEM_TYPE.RAW_MATERIAL || 
      itemType === MATERIAL_ITEM_TYPE.SUB_MATERIAL_PROCESS ||
      itemType === PREFERENCE_ITEM_TYPE.NONE) {
        requestBody = {
          id: id,
          type: type,
          toOrder: toOrder,
          itemType: itemType,
          gcomponentId: itemId
        };
  } else if (itemType === MATERIAL_ITEM_TYPE.SUB_MATERIAL_BUILD) {
    requestBody = {
      id: id,
      type: type,
      toOrder: toOrder,
      itemType: itemType,
      g04docuGCertificationId: itemId
    };
  } else {
    throw new Error('Invalid itemType');
  }

  const response = await csrfFetch(null, `${gcoreServerUrl}/api/gcomponentItems/v2/reorder`, {
    method: "POST",
    body: JSON.stringify(requestBody),
  });

  return response;
}

const initialState = {
  gcomponentItem: null,
  gcomponentItems: [],
  gcomponentItemsByItemType: [],
  gcomponentItemsNotMinesByItemType: [],
  gcomponentItemsSpecific: [],
};

function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    case INIT_GCOMPONENT_ITEM:
      newState = Object.assign({}, state, { gcomponentItem: initialState.gcomponentItem });
      return newState;
    case SET_GCOMPONENT_ITEM:
      newState = Object.assign({}, state, { gcomponentItem: action.payload });
      return newState;
    case REMOVE_GCOMPONENT_ITEM:
      newState = Object.assign({}, state, { gcomponentItem: null });
      return newState;
    case INIT_GCOMPONENT_ITEMS:
      newState = Object.assign({}, state, { gcomponentItems: initialState.gcomponentItems });
      return newState;
    case SET_GCOMPONENT_ITEMS:
      newState = Object.assign({}, state, { gcomponentItems: action.payload });
      return newState;
    case SET_GCOMPONENT_ITEMS_SPECIFIC:
      newState = Object.assign({}, state, { gcomponentItemsSpecific: action.payload });
      return newState; 
    case SET_GCOMPONENT_ITEMS_BY_ITEM_TYPE:
      newState = Object.assign({}, state, { gcomponentItemsByItemType: action.payload });
      return newState;
    case SET_GCOMPONENT_ITEMS_NOT_MINES_BY_ITEM_TYPE:
      newState = Object.assign({}, state, { gcomponentItemsNotMinesByItemType: action.payload });
      return newState;
    default:
      return state;
  }
}

export default reducer;
